<template>
    <div>
        <div class="row">
            <img
                src="@assets/images/banner-testimonial.jpg"
                alt=""
                class="w-100"
            />
        </div>

        <div class="normal-container py-5">
            <div class="row">
                <div class="col-xl-10 mx-auto">
                    <h1 class="text-center">Thank You For Reaching Out!</h1>
                    <h2 class="text-secondary text-center mb-5">
                        We Appreciate The Personal Touch.
                    </h2>

                    <div
                        v-for="testimonial in displayedTestimonials"
                        :key="testimonial.id"
                        class="testimonial-wrap"
                    >
                        <img src="@assets/images/quote-before.png" alt="" />
                        <p class="quote-text">
                            <span
                                ><i>{{ testimonial.description }}</i></span
                            >
                        </p>
                        <p class="quote-author">
                            <i>{{ testimonial.source }}</i>
                        </p>
                    </div>

                    <div
                        v-if="testimonials.length && size < testimonials.length"
                        class="row"
                    >
                        <div class="col-auto mb-lg-1 mb-4">
                            <div class="text-secondary">
                                <button
                                    class="btn btn-link btn-lg"
                                    type="button"
                                    @click="() => (size += 4)"
                                >
                                    READ MORE ...
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
    data() {
        return {
            size: 8, // we start with 8, arbitrarily. Add 4 each time until run out.
        };
    },
    computed: {
        ...mapState('Testimonial', ['testimonials']),
        ...mapGetters('Testimonial', ['areTestimonialsLoaded']),

        displayedTestimonials() {
            return this.testimonials.slice(0, this.size);
        },
    },
    created() {
        if (!this.areTestimonialsLoaded) {
            this.testimonialsRequest();
        }
    },
    methods: {
        ...mapActions('Testimonial', ['testimonialsRequest']),
    },
};
</script>
